import { createSlice } from '@reduxjs/toolkit';
import { FeatureList } from './models';
import { addThunkCases } from './thunks';

export const initialState: FeatureList = {
  status: 'idle',
  message: null,
  featureList: null,
};

export const slice = createSlice({
  name: 'featureList',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearStatus: state => {
      state.status = 'idle';
      state.message = null;
    },
  },
  extraReducers: addThunkCases,
});

export const selectfeatureList = (state: { featureList: FeatureList }) =>
  state.featureList;

export const { clearStatus } = slice.actions;
